import React from 'react';
import type { ReactElement } from 'react';
import 'twin.macro';

import Text from '~components/Text';

interface InfographicProps {
  title: string;
  icon: ReactElement;
}

const Infographic: React.FC<InfographicProps> = ({ title, icon, children }) => (
  <div tw="flex flex-col items-start space-y-6">
    {icon}
    <div>
      <Text tw="my-0 font-bold text-3xl">{title}</Text>
      <Text tw="my-0">{children}</Text>
    </div>
  </div>
);

export default Infographic;
